export { default } from './SocialMedia';
export { default as adapter } from './adapter';
